import { render, staticRenderFns } from "./UtentiDetails.vue?vue&type=template&id=6b68cd56&scoped=true"
import script from "./UtentiDetails.vue?vue&type=script&lang=js"
export * from "./UtentiDetails.vue?vue&type=script&lang=js"
import style0 from "./UtentiDetails.vue?vue&type=style&index=0&id=6b68cd56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68cd56",
  null
  
)

export default component.exports